import { render, staticRenderFns } from "./ProductMonitor.vue?vue&type=template&id=7ad0baec&scoped=true&"
import script from "./ProductMonitor.vue?vue&type=script&lang=js&"
export * from "./ProductMonitor.vue?vue&type=script&lang=js&"
import style0 from "./ProductMonitor.vue?vue&type=style&index=0&id=7ad0baec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad0baec",
  null
  
)

export default component.exports